// constants for navigation

export const NAV_LOGIN = '/login';
export const NAV_SIGN_UP = '/sign-up';
export const NAV_RESET_PASSWORD = '/reset';
export const NAV_KITCHEN = '/kitchen';
export const NAV_DASHBOARD = '/dashboard';
export const NAV_MAKE_PAYMENT = '/make-payment';
export const NAV_RESET= '/reset';